import { render, staticRenderFns } from "./PurchaseDeliveryNote.vue?vue&type=template&id=fec73974&scoped=true"
import script from "./PurchaseDeliveryNote.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliveryNote.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDeliveryNote.vue?vue&type=style&index=0&id=fec73974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec73974",
  null
  
)

export default component.exports